<template>
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="text-center">
      <b-spinner variant="primary" />
      <p class="mt-2 text-muted">Loading Cash Call...</p>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, getCurrentInstance } from '@vue/composition-api'

export default defineComponent({
  name: 'CashCallRedirect',

  setup() {
    onMounted(() => {
      const instance = getCurrentInstance()

      if (!instance || !instance.proxy) return

      const route = instance.proxy.$route
      const router = instance.proxy.$router

      if (!route || !router) return

      const cashCallId = route.query && route.query.cash_call_id
      const bdxKey = route.query && route.query.Bdx_Key
      const action = route.query && route.query.action || "Edit"
      // Set on the Approve link of a TPA approval email when the requester
      // marked the cash call Urgent / High Importance.
      const urgent = !!(route.query && route.query.urgent === 'true')
      const highImportance = !!(route.query && route.query.high_importance === 'true')

      if (!cashCallId) {
        router.replace({ name: 'CashCallDetails' })
        return
      }

      sessionStorage.setItem('directLink', JSON.stringify({
        cashCallId: parseInt(cashCallId),
        bdxKey: bdxKey || null,
        action: action || null,
        urgent: urgent,
        highImportance: highImportance
      }))

      router.replace({ name: 'CashCallDetails' })
    })
  }
})
</script>